import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { observer } from "mobx-react-lite";
import { EExtendsMergeStrategy, EUserRole, TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../others/i18n.js";
import { useStores } from "../../../../../store/root.js";
import { defaultTranslationFlexNamePath, isExtendedFieldHidden } from "../../../../../util/template/form.js";
import { getDisableStrategies } from "../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../util/template/translation.js";
import { getInputPropsDefaultLang, hasTranslationFlagsChanged } from "../../../../../util/translation.js";
import { FormFieldVisibilityWrapper } from "../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../templateMetaDataExtendsStrategyFormField.js";
import { TranslationInputFormFields } from "./translation/language-input/language-input-form-fields.js";
const FormFieldTemplateDisplayName = observer(()=>{
    const { t } = useTranslation();
    const { rcbAuthenticationStore, rcbUserSettingsStore: { settings: { translationSettings } } } = useStores();
    const { isTranslationMode } = translationSettings;
    // Triggers form item re-render on translation mode toggle
    const lastKnownTranslationMode = isTranslationMode;
    const form = Form.useFormInstance();
    const hasCreatorRole = rcbAuthenticationStore.hasRole(EUserRole.Creator);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: TemplateMetaDataField.Name,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST
        },
        forceHiddenFormCallback: isExtendedFieldHidden(TemplateMetaDataField.Name, hasCreatorRole),
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(TemplateMetaDataField.Name, t),
            extra: t("Display name for website visitors when giving consent."),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier || hasTranslationFlagsChanged(prev, next, TemplateMetaDataField.Name) || lastKnownTranslationMode !== isTranslationMode,
            required: true,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                return /*#__PURE__*/ _jsxs(TemplateMetaDataExtendsStrategyFormField, {
                    extendsFieldName: TemplateMetaDataField.Name,
                    disableStrategies: [
                        ...getDisableStrategies()
                    ],
                    defaultStrategy: EExtendsMergeStrategy.Keep,
                    onKeepContent: extended && /*#__PURE__*/ _jsx(Input, {
                        value: extended[TemplateMetaDataField.Name],
                        disabled: true
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(Form.Item, {
                            name: TemplateMetaDataField.Name,
                            rules: [
                                {
                                    max: 255
                                },
                                {
                                    required: hasCreatorRole,
                                    message: t("Please enter a useful display name.", {
                                        lng: translationSettings.sourceLanguage
                                    })
                                }
                            ],
                            hasFeedback: true,
                            noStyle: true,
                            children: /*#__PURE__*/ _jsx(Input, {
                                placeholder: t("Real Cookie Banner"),
                                ...getInputPropsDefaultLang(translationSettings, TemplateMetaDataField.Name, form),
                                disabled: !hasCreatorRole
                            })
                        }),
                        /*#__PURE__*/ _jsx(TranslationInputFormFields, {
                            flexPathConfig: {
                                absolute: {
                                    namePath: defaultTranslationFlexNamePath(TemplateMetaDataField.Name)
                                }
                            }
                        })
                    ]
                });
            }
        })
    });
});
export { FormFieldTemplateDisplayName };
